import {
  MdVerified,
  MdStar,
  MdLocationOn,
  MdCalendarToday,
  MdPayment,
  MdAccessTime,
  MdEventAvailable,
} from 'react-icons/md';
import { t } from '../../utils/i18n';
import { LANDING_AVATARS } from './constants';

export default function HeroPreviewCard() {
  const weekDays = ['P', 'U', 'S', 'Č', 'P', 'S', 'N'];
  const activeDays = [1, 2, 4, 5];

  return (
    <div className="relative w-full max-w-md mx-auto lg:mx-0 lg:ml-auto animate-fade-in" style={{ animationDelay: '0.3s' }}>
      <div className="landing-hero-preview relative rounded-3xl p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <div className="relative flex-shrink-0">
            <img
              src={LANDING_AVATARS.ana}
              alt=""
              className="w-16 h-16 sm:w-[4.5rem] sm:h-[4.5rem] rounded-2xl object-cover ring-2 ring-white/80 dark:ring-white/10 shadow-md"
              loading="lazy"
              referrerPolicy="no-referrer"
            />
            <span className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-olive-500 border-2 border-white dark:border-[var(--color-surface-elevated)] flex items-center justify-center">
              <MdVerified className="text-white text-xs" aria-hidden="true" />
            </span>
          </div>

          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-base sm:text-lg font-semibold text-[var(--color-text)] truncate">
                {t('landing.preview.name')}
              </h3>
              <span className="inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-xs font-semibold landing-preview-rating">
                <MdStar className="text-amber-400 text-sm" aria-hidden="true" />
                4.9
              </span>
            </div>
            <p className="flex items-center gap-1 text-sm text-[var(--color-text-muted)] mt-0.5">
              <MdLocationOn className="text-sm flex-shrink-0" aria-hidden="true" />
              {t('landing.preview.location')}
            </p>
            <span className="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full text-xs font-medium landing-preview-verified">
              <MdVerified className="text-sm" aria-hidden="true" />
              {t('landing.preview.verified')}
            </span>
          </div>
        </div>

        <div className="mt-5 p-3.5 rounded-2xl landing-preview-widget">
          <div className="flex items-center justify-between mb-2.5">
            <span className="text-xs font-semibold text-[var(--color-text-muted)] uppercase tracking-wide flex items-center gap-1.5">
              <MdCalendarToday className="text-sm" aria-hidden="true" />
              {t('landing.preview.thisWeek')}
            </span>
            <span className="text-xs font-bold text-primary-600 dark:text-primary-400">12h</span>
          </div>
          <div className="flex justify-between gap-1">
            {weekDays.map((day, i) => (
              <div
                key={`${day}-${i}`}
                className={`flex flex-col items-center gap-1 flex-1 ${
                  activeDays.includes(i) ? '' : 'opacity-40'
                }`}
              >
                <span className="text-[10px] font-medium text-[var(--color-text-muted)]">{day}</span>
                <span
                  className={`w-7 h-7 rounded-lg flex items-center justify-center text-xs font-semibold ${
                    activeDays.includes(i)
                      ? 'bg-primary-500/15 text-primary-600 dark:text-primary-400 ring-1 ring-primary-500/25'
                      : 'bg-[var(--color-border)]/30 text-[var(--color-text-muted)]'
                  }`}
                >
                  {activeDays.includes(i) ? '✓' : '·'}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-3 flex items-center justify-between gap-2">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold landing-preview-payment">
            <MdPayment className="text-sm" aria-hidden="true" />
            {t('landing.preview.paymentReady')}
          </span>
          <span className="text-xs text-[var(--color-text-muted)]">
            {t('landing.preview.rate')}
          </span>
        </div>
      </div>

      <div
        className="landing-floating-card absolute -left-2 sm:-left-6 bottom-8 sm:bottom-12 px-3.5 py-2.5 rounded-2xl flex items-center gap-2 animate-float hidden sm:flex"
        aria-hidden="true"
      >
        <MdAccessTime className="text-primary-500 dark:text-primary-400 text-lg flex-shrink-0" />
        <span className="text-xs sm:text-sm font-semibold text-[var(--color-text)] whitespace-nowrap">
          {t('landing.preview.hoursTracked')}
        </span>
      </div>

      <div
        className="landing-floating-card absolute -right-2 sm:-right-4 top-6 sm:top-8 px-3.5 py-2.5 rounded-2xl flex items-center gap-2 animate-float-delay-1 hidden sm:flex"
        aria-hidden="true"
      >
        <MdEventAvailable className="text-olive-600 dark:text-olive-400 text-lg flex-shrink-0" />
        <span className="text-xs sm:text-sm font-semibold text-[var(--color-text)] whitespace-nowrap">
          {t('landing.preview.confirmedShifts')}
        </span>
      </div>
    </div>
  );
}
